import { saveContactDetails } from '@mmt/legacy-commons/Common/Components/ContactDetails/contactDetailsUtils';
import { getClassType } from '../Types/ClassType';
import {
  getMaxTravelersAllowedForBooking,
  showBoardingStationChangeOption,
} from '../TravelerDetails/TravelerDetailsUtils';
import { getBoardingStation } from '../../Utils/RailsAPIRepository';
import { getMealPreferenceOptions1 } from '../Constants/MealNew';
import { getBerthPreferenceOptions } from '../Constants/Berth';
import { getNationalityOptions } from '../Constants/Country';
import { getSrCitizenOptions } from '../Constants/SrCitizenConcession';
import {
  ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
  ACTION_LOAD_PREFERENCES,
  isValidIrctcUserName,
} from '../TravelerDetails/TravelerDetailsActions';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import { _label } from '../../vernacular/AppLanguage';
import {
  ACTION_BOOKING_REVIEW_LOAD,
  ACTION_BOOKING_REVIEW_SUCCESS,
  getInsuranceCharge,
  getPassengerList,
  getReviewPageCommonData,
} from '../Review/RailsReviewActions';
import { registerScheduleTatkal, scheduleTatkalBookingReview } from './api/ScheduleTatkalApi';
import { RegisterScheduleTatkalRequest, ScheduleTatkalReviewRequest } from './api/interface';
import { bookMode, isMweb } from '../../Utils/device';
import isEmpty from 'lodash/isEmpty';
import fecha from 'fecha';
import {
  convertFromEpochToHoursAndMinsFormat,
  initServerTravelersMetaDataForScheduledTatkal,
  validateScheduleTatkalTravelerDetails,
} from './utils/ScheduleTatkalTravelerUtils';
import { convertEpochToTimeFormat } from '../../Utils/RisUtils';
import { Actions } from '../../navigation';
import { ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE } from '../NewListing/RailsListingActions';
import { getQuota } from '../Types/QuotaType';
import { openScheduleTatkalTravelerPage } from '../NewListing/RailsListingActionsV3';
import { updateUsername } from '../User/UserVerification/UserVerificationActions';
import { RAILS_MMT_ID, setDataToAsyncStorage } from '../../Utils/RailsConstant';
import { trackAndSetDataForReviewPageLoad } from '../../railsAnalytics';

export const SCHEDULE_TATKAL_ACTIONS_LIST = {
  ACTION_INIT_STATE: 'ACTION_INIT_STATE',
  ACTION_ON_CONTACT_DETAILS_EDITED: 'ACTION_ON_CONTACT_DETAILS_EDITED',
  ACTION_SCHEDULE_TATKAL_CARD_CLICK: 'ACTION_SCHEDULE_TATKAL_CARD_CLICK',
  ACTION_LOAD_BOARDING_STATION: 'ACTION_LOAD_BOARDING_STATION',
  ACTION_ON_BOARDING_STATION_CHANGE: 'ACTION_ON_BOARDING_STATION_CHANGE',
};

export const onScheduleTatkalSubmitClick = () => async (dispatch: any, getState: any) => {
  try {
    const state = getState();
    if (!dispatch(validateScheduleTatkalTravelerDetails(state))) {
      return false;
    }
    const {
      scheduleTatkalTraveler: {
        contactDetails = {},
        selectedTrainInfo,
        selectedClassType,
        selectedPickupStation,
        bkgCfg: { childBerthMandatory, seniorCitizenApplicable },
        scheduleTatkalFormDetails = {},
      },
      railsUserVerification: { irctcUserName },
      railsTraveler: { gstDetails, optionalGstDetailsEnabled, selectedTravelers, travelers },
    } = state || {};
    const payload: RegisterScheduleTatkalRequest = {
      journeyDetails: {
        source: selectedTrainInfo?.frmStnCode,
        sourceName: selectedTrainInfo?.frmStnName,
        destination: selectedTrainInfo?.toStnCode,
        destinationName: selectedTrainInfo?.toStnName,
        journeyClass: selectedClassType,
        doj: fecha.format(selectedTrainInfo.departureDateAndTime, 'YYYYMMDD'),
        trainNumber: selectedTrainInfo.trainNumber,
        trainName: selectedTrainInfo.trainName,
        departureTime: selectedTrainInfo?.departureTimeEpochInSec,
        arrivalTime: selectedTrainInfo?.arrivalTimeEpochInSec,
      },
      boardingStation: selectedPickupStation?.stationCode,
      passengerList: getPassengerList(
        selectedTravelers,
        travelers,
        { code: 'TQ' },
        childBerthMandatory,
        seniorCitizenApplicable,
        true,
      ),
      irctcUserId: irctcUserName,
      ...(optionalGstDetailsEnabled && { gstDetails }),
      mobileNumber: contactDetails?.mobile,
      email: contactDetails?.email,
    };

    const res = await registerScheduleTatkal(payload, scheduleTatkalFormDetails?.formId);
    if (res?.error || res?.errorMessage) {
      showShortToast(res?.errorMessage || _label('something_went_wrong_try_again_later'));
      return false;
    }
    dispatch({
      type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_INIT_STATE,
      data: { scheduleTatkalFormDetails: res },
    });
    return true;
  } catch (error) {
    console.error('Error in registerScheduleTatkal', error);
    showShortToast(_label('something_went_wrong_try_again_later'));
  }
};

export const onContactDetailsValidationFailed =
  (fieldName: any) => (dispatch: any, getState: any) => {
    let { scheduleTatkalTraveler: { contactDetails = {} } = {} } = getState();
    contactDetails = {
      ...contactDetails,
      hasCompleteFields: false,
      [fieldName]: '',
    };

    dispatch({
      type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_ON_CONTACT_DETAILS_EDITED,
      data: contactDetails,
    });

    saveContactDetails(contactDetails, 'RAILS');
  };

export const saveContactCallBackHandler = (contactDetails: any) => (dispatch: any) => {
  dispatch({
    type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_ON_CONTACT_DETAILS_EDITED,
    data: contactDetails,
  });
  saveContactDetails(contactDetails, 'RAILS');
};

export const loadScheduleTatkalBoardingStation =
  (boardingStationCode?: string) => async (dispatch: any, getState: any) => {
    let classValue = null;
    let boardingStationList = [];
    let showBoardingStationChange = false;
    let selectedPickupStation = null;
    try {
      const {
        scheduleTatkalTraveler: { selectedClassType, selectedTrainInfo },
      } = getState();

      classValue = getClassType(selectedClassType);
      showBoardingStationChange = showBoardingStationChangeOption('');

      if (showBoardingStationChange) {
        boardingStationList = await getBoardingStation(selectedTrainInfo, classValue);
        selectedPickupStation = boardingStationList
          ? selectedTrainInfo?.boardingStation
            ? boardingStationList.find(
                (station) =>
                  station?.stationCode ===
                  (boardingStationCode || selectedTrainInfo?.boardingStation?.code),
              )
            : boardingStationList[0]
          : null;
      }
      dispatch({
        type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_LOAD_BOARDING_STATION,
        data: {
          showBoardingStationChange,
          boardingStationList,
          selectedPickupStation,
        },
      });
      dispatch({
        type: ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
        data: { selectedPickupStation, boardingStationList },
      });
    } catch (e) {
      console.log('Error in loadBoardingStation for scheduled tatkal traveler page :', e);
    }
  };

export const onScheduleTatkalBoardingStationChange = (station: any) => (dispatch: any) => {
  dispatch({
    type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_ON_BOARDING_STATION_CHANGE,
    data: {
      selectedPickupStation: station?.obj,
    },
  });
};

export const loadScheduleTatkalTravelerPreferences = (config: any) => (dispatch: any) => {
  const { applicableBerthTypes = [], applicableFoodTypes = null } = config || {};
  let mealOptions = {};
  let berthOptions = {};
  let srOptions = {};
  let nationalityOptions = {};
  try {
    mealOptions = getMealPreferenceOptions1(applicableFoodTypes);
    berthOptions = getBerthPreferenceOptions(applicableBerthTypes);
    srOptions = getSrCitizenOptions();
    nationalityOptions = getNationalityOptions();
    dispatch({
      type: ACTION_LOAD_PREFERENCES,
      data: {
        mealOptions,
        berthOptions,
        srOptions,
        nationalityOptions,
      },
    });
  } catch (e) {
    console.log('Error in loadPreferences :', e);
  }
};

// Schedule Tatkal Review Click from Landing Page
export const onScheduleTatkalReviewClick = (form: any) => async (dispatch: any, getState: any) => {
  try {
    const {
      railsLanding: { bookingSource = '' },
    } = getState();
    const bookingReviewRequest: ScheduleTatkalReviewRequest = {
      source: isMweb() ? 'RNW' : 'RN',
      gatewayChargeEnabled: true,
      reservationChoice: form?.reservationChoice ?? '99',
      wsUserLogin: form?.irctcUserId,
      mobileNumber: form?.mobileNumber,
      email: form?.email,
      boardingStation: form?.boardingStation,
      autoUpgradationSelected: form?.autoUpgradationSelected ?? true,
      travelInsuranceOpted: form?.travelInsuranceOpted ?? true,
      bookMode: bookMode(),
      journeyDetails: {
        source: form?.journeyDetails?.source,
        destination: form?.journeyDetails?.destination,
        class: form?.journeyDetails?.journeyClass,
        quota: 'TQ',
        doj: form?.journeyDetails?.doj,
        trainDetails: {
          trainNumber: form?.journeyDetails?.trainNumber,
          departureTime: convertEpochToTimeFormat(form?.journeyDetails?.departureTime),
        },
      },
      passengerList: form?.passengerList,
      ...(!isEmpty(form?.gstDetails) && { gstDetails: form?.gstDetails }),
      scheduledTatkalFormId: form?.formId,
    };
    const jsonResponse = await scheduleTatkalBookingReview(bookingReviewRequest, bookingSource);
    if (!jsonResponse?.error && !jsonResponse?.errorMessage) {
      setDataToAsyncStorage(RAILS_MMT_ID, jsonResponse?.mmtId);
      const selectedTrainInfo = {
        frmStnCode: form?.journeyDetails?.source,
        frmStnName: form?.journeyDetails?.sourceName,
        toStnCode: form?.journeyDetails?.destination,
        toStnName: form?.journeyDetails?.destinationName,
        arrivalTimeEpochInSec: form?.journeyDetails?.arrivalTime,
        departureTimeEpochInSec: form?.journeyDetails?.departureTime,
        arrivalTime: convertFromEpochToHoursAndMinsFormat(form?.journeyDetails?.arrivalTime),
        departureTime: convertFromEpochToHoursAndMinsFormat(form?.journeyDetails?.departureTime),
        departureDateAndTime: new Date(form?.journeyDetails?.departureTime * 1000),
        arrivalDateAndTime: new Date(form?.journeyDetails?.arrivalTime * 1000),
        trainNumber: form?.journeyDetails?.trainNumber,
        trainName: form?.journeyDetails?.trainName,
        duration:
          ((form?.journeyDetails?.arrivalTime ?? 0) - (form?.journeyDetails?.departureTime ?? 0)) /
          60,
        ...(!isEmpty(form?.boardingStation) && {
          boardingStation: {
            code: form?.boardingStation,
          },
        }),
      };
      const dispatchData = {
        selectedTrainInfo,
        selectedQuota: getQuota('TQ'),
      };
      dispatch({
        type: ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE,
        data: dispatchData,
      });
      dispatch({
        type: ACTION_BOOKING_REVIEW_LOAD,
        data: {
          bookingReviewRequest,
        },
      });
      dispatch({
        type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_SCHEDULE_TATKAL_CARD_CLICK,
        data: {
          selectedTrainInfo,
          selectedClassType: form?.journeyDetails?.journeyClass || '',
          bkgCfg: form?.bkgCfg || {},
          scheduleTatkalFormDetails: form,
        },
      });
      dispatch(loadScheduleTatkalBoardingStation(form?.boardingStation));
      const config = {
        applicableBerthTypes: form?.bkgCfg?.applicableBerthTypes || [],
        foodChoiceEnabled: form?.bkgCfg?.foodChoiceEnabled ?? false,
        selectedQuota: getQuota('TQ'),
        classValue: getClassType(form?.journeyDetails?.journeyClass),
        seniorCitizenApplicable: form?.bkgCfg?.seniorCitizenApplicable ?? false,
        applicableFoodTypes: form?.bkgCfg?.applicableFoodTypes || null,
      };
      dispatch(loadScheduleTatkalTravelerPreferences(config));
      const { travelers = [], selectedTravelers = [] } =
        initServerTravelersMetaDataForScheduledTatkal(form?.passengerList || [], config);
      const travelerDispatchData = {
        ...(form?.bkgCfg || {}),
        selectedQuota: getQuota('TQ'),
        travelers,
        selectedTravelers,
        showViewAll: false,
        optionalGstDetailsEnabled: false,
        ...(!isEmpty(form?.gstDetails) && { optionalGstDetailsEnabled: true }),
        gstDetails: form?.gstDetails || { nameOnGst: '', gstIn: '' },
        ...(!isEmpty(form?.boardingStation) && {}),
        classValue: getClassType(form?.journeyDetails?.journeyClass),
      };
      dispatch({
        type: ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
        data: travelerDispatchData,
      });
      dispatch({
        type: ACTION_BOOKING_REVIEW_SUCCESS,
        data: {
          reviewTimeStamp: Date.now(),
          bookingReviewSuccess: true,
          errorMessage: null,
          bookingReviewResponse: jsonResponse,
          currentAvailabilityStatus: jsonResponse?.avlDayList[0]?.availablityStatus,
          baseFare: jsonResponse?.mmtBaseFare,
          gstPrice: 0,
          mmtServiceCharge: jsonResponse?.mmtServiceFee,
          totalCollectibleAmount: jsonResponse?.totalCollectibleAmount,
          paymentInfo: jsonResponse?.paymentInfo,
          insuranceCharge: getInsuranceCharge(jsonResponse),
          durationFromBoardingStation: jsonResponse?.durationFromBoardingStation,
          dueAmount: jsonResponse?.dueAmount,
          dueDate: jsonResponse?.dueDate,
          displayIrctcPassBottomsheet:
            jsonResponse?.interventions?.irctcPasswordBottomSheet?.display || 0,
        },
      });
      const { railsListing, railsTraveler } = getState();
      Actions.railsReviewPage({
        isScheduleTatkalBooking: true,
      });
      trackAndSetDataForReviewPageLoad(
        getReviewPageCommonData(jsonResponse, railsListing, railsTraveler),
      );
      return;
    }
    showShortToast(jsonResponse?.errorMessage || _label('something_went_wrong_try_again_later'));
  } catch (error) {
    console.error('Error in onScheduleTatkalReviewClick', error);
    showShortToast(_label('something_went_wrong_try_again_later'));
  }
};

// Landing page edit schedule tatkal click
export const onEditScheduleTatkalDetailsClick =
  (form: any) => async (dispatch: any, getState: any) => {
  try {
    const selectedTrainInfo = {
      frmStnCode: form?.journeyDetails?.source,
      frmStnName: form?.journeyDetails?.sourceName,
      toStnCode: form?.journeyDetails?.destination,
      toStnName: form?.journeyDetails?.destinationName,
      arrivalTimeEpochInSec: form?.journeyDetails?.arrivalTime,
      departureTimeEpochInSec: form?.journeyDetails?.departureTime,
      arrivalTime: convertFromEpochToHoursAndMinsFormat(form?.journeyDetails?.arrivalTime),
      departureTime: convertFromEpochToHoursAndMinsFormat(form?.journeyDetails?.departureTime),
      departureDateAndTime: new Date(form?.journeyDetails?.departureTime * 1000),
      arrivalDateAndTime: new Date(form?.journeyDetails?.arrivalTime * 1000),
      trainNumber: form?.journeyDetails?.trainNumber,
      trainName: form?.journeyDetails?.trainName,
      duration:
        ((form?.journeyDetails?.arrivalTime ?? 0) - (form?.journeyDetails?.departureTime ?? 0)) /
        60,
      ...(!isEmpty(form?.boardingStation) && {
        boardingStation: {
          code: form?.boardingStation,
        },
      }),
    };
    const contactDetails = {
      mobile: form?.mobileNumber,
      email: form?.email,
      hasCompleteFields: true,
    };
    const config = {
      applicableBerthTypes: form?.bkgCfg?.applicableBerthTypes || [],
      foodChoiceEnabled: form?.bkgCfg?.foodChoiceEnabled ?? false,
      selectedQuota: getQuota('TQ'),
      classValue: getClassType(form?.journeyDetails?.journeyClass),
      seniorCitizenApplicable: form?.bkgCfg?.seniorCitizenApplicable ?? false,
      applicableFoodTypes: form?.bkgCfg?.applicableFoodTypes || null,
    };
    const { travelers = [], selectedTravelers = [] } =
      initServerTravelersMetaDataForScheduledTatkal(form?.passengerList || [], config);
    dispatch({
      type: SCHEDULE_TATKAL_ACTIONS_LIST.ACTION_SCHEDULE_TATKAL_CARD_CLICK,
      data: {
        selectedTrainInfo,
        selectedClassType: form?.journeyDetails?.journeyClass || '',
        bkgCfg: form?.bkgCfg || {},
        scheduleTatkalFormDetails: form,
        contactDetails,
      },
    });
    dispatch(loadScheduleTatkalBoardingStation(form?.boardingStation));
    const listingDispatchData = {
      ...(form?.bkgCfg || {}),
      applicableFoodTypes: form?.bkgCfg?.applicableFoodTypes || null,
    };
    dispatch({
      type: ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE,
      data: listingDispatchData,
    });
    const maxTravelersAllowed = getMaxTravelersAllowedForBooking(getQuota('TQ'));
    const travelerDispatchData = {
      ...(form?.bkgCfg || {}),
      selectedQuota: getQuota('TQ'),
      travelers,
      selectedTravelers,
      showViewAll: false,
      optionalGstDetailsEnabled: false,
      ...(!isEmpty(form?.gstDetails) && { optionalGstDetailsEnabled: true }),
      gstDetails: form?.gstDetails || { nameOnGst: '', gstIn: '' },
      maxTravelersAllowed,
    };
    dispatch({
      type: ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
      data: travelerDispatchData,
    });
    // prefill irctc username if valid
    dispatch(updateUsername(null));
      if (form?.irctcUserId) {
        const { railsTraveler: { selectedQuota = null } = {} } = getState() || {};
        const headers = {
          quota: selectedQuota?.code,
        };
        const isValidUserName = await isValidIrctcUserName(form?.irctcUserId, headers);
      if (isValidUserName) {
        dispatch(updateUsername(form?.irctcUserId));
      }
    }
    dispatch(loadScheduleTatkalTravelerPreferences(config));
    dispatch(openScheduleTatkalTravelerPage());
  } catch (error) {
    console.error('Error in onEditScheduleTatkalDetailsClick', error);
    showShortToast(_label('something_went_wrong_try_again_later'));
  }
};

export const unLoadScheduleTatkalTravelerPage = () => (dispatch: any) => {
  const travelerDispatchData = {
    travelers: [],
    selectedTravelers: [],
    showViewAll: false,
    optionalGstDetailsEnabled: false,
    gstDetails: { nameOnGst: '', gstIn: '' },
  };
  dispatch({
    type: ACTION_INIT_SCHEDULE_TATKAL_TRAVELER,
    data: travelerDispatchData,
  });
};
